import React, { useEffect, useState } from 'react'
import styles from './Redirect.module.css'

// NOTE: このホワイトリストはバックエンド側（app/controllers/proxy/redirect_controller.rb）
// のALLOWED_DOMAINSと同期する必要があります。更新時は両方のファイルを更新してください。
const ALLOWED_DOMAINS = ['liff.line.me', 'coubic.com', 'www.youtube.com', 'foodslabo.stores.jp']

function isAllowedUrl(url: string): boolean {
    try {
        let urlToCheck = url
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            urlToCheck = `https://${url}`
        }
        const urlObj = new URL(urlToCheck)
        const hostname = urlObj.hostname

        return ALLOWED_DOMAINS.some(domain => hostname === domain || hostname.endsWith(`.${domain}`))
    } catch {
        return false
    }
}

export default function Redirect() {
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const redirectUrl = urlParams.get('redirect-url')

        if (!redirectUrl) {
            setError('redirect-urlパラメータが指定されていません')
            return
        }

        if (!isAllowedUrl(redirectUrl)) {
            setError('許可されていないリダイレクト先です')
            // eslint-disable-next-line no-console
            console.error('許可されていないリダイレクト先:', redirectUrl)
            return
        }

        let finalUrl = redirectUrl
        if (!redirectUrl.startsWith('http://') && !redirectUrl.startsWith('https://')) {
            finalUrl = `https://${redirectUrl}`
        }

        window.location.href = finalUrl
    }, [])

    if (error) {
        return (
            <div className={styles.container}>
                <div className={styles.error}>
                    <p>{error}</p>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <svg className={styles.pl} width="240" height="240" viewBox="0 0 240 240">
                <circle className={`${styles.pl__ring} ${styles['pl__ring--a']}`} cx="120" cy="120" r="105" fill="none" stroke="#000" strokeWidth="20" strokeDasharray="0 660" strokeDashoffset="-330" strokeLinecap="round" />
                <circle className={`${styles.pl__ring} ${styles['pl__ring--b']}`} cx="120" cy="120" r="35" fill="none" stroke="#000" strokeWidth="20" strokeDasharray="0 220" strokeDashoffset="-110" strokeLinecap="round" />
                <circle className={`${styles.pl__ring} ${styles['pl__ring--c']}`} cx="85" cy="120" r="70" fill="none" stroke="#000" strokeWidth="20" strokeDasharray="0 440" strokeLinecap="round" />
                <circle className={`${styles.pl__ring} ${styles['pl__ring--d']}`} cx="155" cy="120" r="70" fill="none" stroke="#000" strokeWidth="20" strokeDasharray="0 440" strokeLinecap="round" />
            </svg>
            <div className={styles.text}>読み込み中...</div>
        </div>
    )
}
